module.exports = __webpack_public_path__ + "static/media/player-placeholder.04a27347.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/containers/Mundial2026/FootballMatchDetail/assets/player-placeholder.jpg
// module id = 2608
// module chunks = 0